<template>
  <b-button
    @click="trigger"
    size="sm"
    variant="light"
    block
    >
    <i class="fa" :class="marker ? 'fa-map-marked' : 'fa-map'" />
  </b-button>
</template>

<script>
import common from '@/mixins/common.js'

export default {
  name: "MarkerSwitch",
  mixins: [common],
  components: {
    
  },
  props: {
    value: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      marker: this.value,
    }
  },
  watch: {
    marker(newValue) {
      this.$emit('input', newValue);
      this.$nextTick(() => {
        localStorage.setItem("marker", newValue);
      })
    },
  },
  methods: {
    trigger() {
      this.marker = !this.marker;
    },
    init() {
      var marker = localStorage.getItem("marker");
      if (typeof marker !== 'undefined' && marker !== null) {
        if(marker === 'true') {
          this.marker = true;
        } else {
          this.marker = false;
        }
      }
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<style>
</style>
